import { Button, Divider, Grid, Typography } from '@mui/material';
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { getFullName } from 'src/common/utils/format-utils';
import { AppealStatus } from 'src/enums/application-status.enum';
import { dateFormat } from '../../../hooks';
import { BaseDialog } from '../../dialogs';
import useStyles from './styles';

interface AppealsDialogProps {
  resolve?: () => void;
  reject?: () => void;
  popDialog?: any;
  item: Record<string, any>;
}

export const AppealsDialog: ComponentType<AppealsDialogProps> = ({
  resolve,
  reject,
  popDialog,
  item,
  ...props
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  // const [isExtended, toggleExtended] = useToggle(false);

  const { id, user, appealDescription, updatedAt } = item;
  // const { attestationDate, createdAt, id, user, appealDescription, questions, updatedAt } = item;

  // const numberedItems = map(questions, (item, index) =>
  //   omit({ ...item, index: index + 1 }, 'correctAnswer')
  // );
  // const filteredQuestions = filter(numberedItems, (item) => !item.isCorrect);

  return (
    <BaseDialog {...{ ...props, popDialog }}>
      <div className={classes.root}>
        <Typography variant="h2" component="h6" mb={2}>
          {t('appeals.request.title', `Заявка на апелляцию №${id}`, { id })}
        </Typography>

        <Grid container direction="column" spacing={2} mb={4}>
          <Grid item>
            <Grid container columnSpacing={1}>
              <Grid item>
                <Typography variant="body2" color="grey.400">
                  {t('name.full', 'ФИО')}:
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="h5" color="grey.800">
                  {getFullName(user)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container columnSpacing={1}>
              <Grid item>
                <Typography variant="body2" color="grey.400">
                  {t('date.attestation', 'Дата аттестации')}:
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="h5" color="grey.800">
                  {dateFormat(updatedAt)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          {/* <Grid item>
            <Grid container columnSpacing={1}>
              <Grid item>
                <Typography variant="body2" color="grey.400">
                  {t('date.appeal', 'Дата подачи апелляции')}:
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="h5" color="grey.800">
                  {dateFormat(updatedAt)}
                </Typography>
              </Grid>
            </Grid>
          </Grid> */}
        </Grid>

        <Typography variant="h3" mb={2}>
          {t('appeal.explanation', 'Пояснение к апелляции')}
        </Typography>

        <Typography variant="body2" component="p" mb={4}>
          {appealDescription}
        </Typography>

        {/* <Typography variant="h3" mb={3}>
          {t('answers.incorrect', 'Неправильные ответы')}
        </Typography>

        <Collapse in={isExtended}>
          <div className={classes.tests}>
            {map(
              filteredQuestions.sort((a, b) => a.droppedQuestionId - b.droppedQuestionId),
              (item, idx) => (
                <TestQuestionsItem
                  className={classes.test}
                  item={item}
                  index={item.droppedQuestionId}
                  key={item.id}
                  disabled
                  highlightError={false}
                />
              )
            )}
          </div>
        </Collapse> */}

        {/* <Typography
          onClick={toggleExtended}
          className={classes.toggler}
          variant="body2"
          component="button"
        >
          {isExtended
            ? t('answers.incorrect.hide', 'Скрыть неправильные ответы')
            : t('answers.incorrect.show', 'Показать неправильные ответы')}
        </Typography> */}

        <Divider sx={{ my: 4 }} />

        <Grid container columnSpacing={3}>
          <Grid item sx={{ mr: 'auto' }}>
            <Button onClick={popDialog} variant="outlined" size="large">
              {t('cancel', 'Отмена')}
            </Button>
          </Grid>
          {item.appealStatus === AppealStatus.PENDING && (
            <>
              <Grid item>
                <Button onClick={reject} variant="contained" color="error" size="large">
                  {t('action.decline', 'Отклонить')}
                </Button>
              </Grid>
              <Grid item>
                <Button onClick={resolve} variant="contained" color="success" size="large">
                  {t('action.confirm', 'Одобрить')}
                </Button>
              </Grid>
            </>
          )}
        </Grid>
      </div>
    </BaseDialog>
  );
};
